import React, { useState } from "react";
import "../styles/IntakeForm.css";

const IntakeForm = ({ isOpen, onClose }) => {
  const [selectedOptions, setSelectedOptions] = useState({
    Website: false,
    App: false,
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Remove or set to false in production
  const [forceShowThankYou, setForceShowThankYou] = useState(false);

  if (!isOpen) return null;

  const handleOptionChange = (e) => {
    const { name, checked } = e.target;
    setSelectedOptions((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formData = new FormData(e.target);
      formData.append("Website", selectedOptions.Website);
      formData.append("App", selectedOptions.App);

      const response = await fetch('https://submit-form.com/33k571r3T', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json' // This tells FormSpark to return JSON instead of redirecting
        },
      });
      
      if (response.ok) {
        setIsSubmitted(true);
        setIsSubmitting(false);
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setIsSubmitting(false);
      // Show thank you anyway for better UX (optional)
      // setIsSubmitted(true);
      alert("Er is een fout opgetreden bij het verzenden van het formulier. Probeer het opnieuw.");
    }
  };

  const handleCloseThankYou = () => {
    setIsSubmitted(false);
    setSelectedOptions({
      Website: false,
      App: false,
    });
    onClose();
  }

  // Show thank you overlay if submitted or forced (for editing)
  if (isSubmitted || forceShowThankYou) {
    return (
      <div className="intake-form-overlay">
        <div className="thank-you-content">
          <div className="thank-you-message">
            <h2>🎉 Bedankt voor je aanvraag!</h2>
            <p>We hebben je bericht ontvangen en nemen binnen 24 uur contact met je op.</p>
            <p>Check ook je spam/ongewenste e-mail folder voor het geval onze reactie daar terechtkomt.</p>
            <button className="thank-you-button" onClick={handleCloseThankYou}>
              Sluiten
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="intake-form-overlay">
      <div className="intake-form-content">
        <button className="close-button" onClick={onClose}>
          X
        </button>
        <h2>Dit is de start van jouw digitale groei</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-columns">
            <div className="intake-form-column1">
              <label>
                Naam:
                <input
                  type="text"
                  name="name"
                  required
                  placeholder="Voor- en achternaam"
                  disabled={isSubmitting}
                />
              </label>
              <label>
                Email:
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="voorbeeld@gmail.com"
                  disabled={isSubmitting}
                />
              </label>
              <label>
                Telefoon:
                <input
                  type="tel"
                  name="phone"
                  required
                  placeholder="06-12345678" // Fixed typo: was "placeHolder"
                  disabled={isSubmitting}
                />
              </label>
            </div>
            <div className="intake-form-column2">
              <label className="option-label">Ik wil een:</label>
              <label>
                <input
                  type="checkbox"
                  name="Website"
                  checked={selectedOptions.Website}
                  onChange={handleOptionChange}
                  disabled={isSubmitting}
                />
                <span className="option-text">Website</span>
              </label>
              <label>
                <input
                  type="checkbox"
                  name="App"
                  checked={selectedOptions.App}
                  onChange={handleOptionChange}
                  disabled={isSubmitting}
                />
                <span className="option-text">App</span>
              </label>
              <label>
                <textarea
                  name="uitleg"
                  placeholder="Voeg beschrijving toe.. 
                  (Denk aan:
                  Target Audience, 
                  Functionaliteiten,
                  Handige informatie om te delen)"
                  required
                  disabled={isSubmitting}
                />
              </label>
            </div>
          </div>
          <button className="submitButton" type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Verzenden...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default IntakeForm;